module.exports = __webpack_public_path__ + "img/service.313fc6c0.jpeg";